<template>
    <v-card-text>
        <v-container fluid>
            <v-row dense align="center" justify="center">
                <v-col cols="12" sm="3" v-for="(v,k) in listAccesorios" :key="k">
                    <div class="text-center">
                        <v-img :src="v.base64" contain :height="size" :max-height="size"></v-img>
                        <span class="body-2 font-weight-bold" v-html="v.accesorio"></span><br/>
                        <span class="caption" v-html="v.valorAsegurado"></span>
                    </div>
                </v-col>
            </v-row>
            
            <v-row dense>
                <v-col cols="12" sm="12">
                    <div class="mt-3 text-right">
                        <v-btn rounded dark color="secondary" @click="verDocumento">Ver Documentos</v-btn>
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </v-card-text>
</template>

<script>
    export default {
        name: 'windowInformacionAccesoriosComponent',
        inject: ['setData', 'setStep'],
        props: {
            active: {
                type: Boolean,
                default: false
            },
            obBusqueda: {
                type: Object,
                default: {}
            },
            listAccesorios: {
                type: Array,
                default: () => []
            },
            parametros:{
                type:Object,
                default:{}
            }
        },
        created(){
            this.onListarAccesorios();
        },
        computed:{
            size(){
                var s = _.size(this.listAccesorios);
                
                if(this.$root.isTouch)
                    return 100;
                else if(s < 3)
                    return 300;
                else    
                    return 200;
            }
        },
        watch:{
            active(val){
                if(val && _.size(this.listAccesorios) == 0){
                    this.onListarAccesorios();
                }
            }
        },
        methods:{
            verDocumento(){
                this.setStep(6);
            },
            onListarAccesorios(){
                var error = 'E';
                var o = _.merge({ opcion:'L_ACCESORIOS_X_CERTIFICADO'},
                                _.pick(this.obBusqueda,['idCertificado','idPoliza'])
                                );

                axios.post(`${BASE_URI}administrador/t-inclusion-exclusion-accesorio/listar`,o)
                     .then((r)=>{
                        if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                        if(_.size(_.get(r,['data','data'])) == 0){ error='I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); } 
                            var l = _.cloneDeep(r.data.data);

                            l = _.map(l,(v)=>{
                                    var s = _.split(v.base64,',');
                                    v.base64 = _.includes(v.base64,'data:image/svg') ? `data:image/svg+xml;base64,${s[1]}` : v.base64;
                                    v.valorAsegurado = `$ ${v.valorAsegurado}`;
                                return v;
                            });
                            
                            this.setData('listGeneral.listAccesorios',l);
                     })
                     .catch((e)=>{
                         mensajesAlerta(e,error);
                     });
            }
        }
    }
</script>